import React, { useRef, useState } from 'react';
import Button from '@components/Button';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const CopyToChildren = ({
  content,
  children = 'Copy to Clipboard',
  onCopy = () => {},
  className = ''
}) => {
  const textAreaRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const copyToClipboard = evt => {
    textAreaRef.current.select();
    document.execCommand('copy');
    evt.target.focus();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    onCopy();
  };

  return (
    <>
      <textarea
        style={{
          height: 0,
          opacity: 0,
          width: 0
        }}
        readOnly
        ref={textAreaRef}
        value={content}
        aria-label="Copy to Clipboard"
      />

      <Button
        onClick={copyToClipboard}
        startIcon={copied ? <AssignmentTurnedInIcon /> : <FileCopyIcon />}
        className={className}
      >
        {copied ? 'Copied to Clipboard' : children}
      </Button>
    </>
  );
};

export default CopyToChildren;
